import {createContext} from 'react'

import {QuantityRange} from '../../../../fields'

export type OrderConfirmationContextProps =
  | {isEnabled: false}
  | {
      isEnabled: true
      quantityRange: QuantityRange
    }

export const OrderConfirmationContext = createContext<OrderConfirmationContextProps | undefined>(
  undefined
)
